import { Box, Button, Grid, Typography } from "@mui/material";
import { DateCalendar, MonthCalendar, YearCalendar } from "@mui/x-date-pickers";
import styled from "styled-components";
import Colors from "@constants/Colors";

export const StyledBox = styled(Box)`
  background-color: ${Colors.neutral_gray_100};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 4px;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
  border-radius: 8px 8px 0px 0px;
`;

export const StyledTypography = styled(Typography)<{ date?: string }>`
  text-align: center;
  font-family: ${({ date }: { date?: string }) =>
    date ? "Ringside Regular-Bold" : "Ringside Regular-Book"}!important;
  font-weight: ${({ date }: { date?: string }) =>
    date ? "400" : "325"}!important;
  font-size: ${({ date }: { date?: string }) =>
    date ? "24px" : "16px"} !important;
  line-height: ${({ date }: { date?: string }) =>
    date ? "32px" : "24px"} !important;
  color: ${({ date }: { date?: string }) =>
    date ? Colors.neutralblack : Colors.neutral_gray_500};
`;

export const StyledBoxHeading = styled(Box)`
  padding: 0px 16px;
  color: ${Colors.neutral_gray_500} !important;
`;

export const StyledSelectionRow = styled(Box)`
  padding: 8px;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap !important;
`;

export const StyledIcon = styled("img")`
  height: 24px;
  fill: red !important;
  width: 24px;
`;

export const StyledButton = styled(Button)<{ selected: boolean }>`
  border: 1px solid ${Colors.primary_600} !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  border-radius: 8px !important;
  text-transform: capitalize !important;
  min-width: 100% !important;
  height: 52px !important;
  justify-content: space-evenly !important;
  color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.white : Colors.primary_600} !important;
  background-color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.primary_600 : "transparent"} !important;
`;

export const StyledDateCalendar = styled(DateCalendar)`
  color: ${Colors.neutral_gray_900} !important;
  width: 100% !important;

  .MuiPickersCalendarHeader-root {
    display: none;
  }
  .MuiDayCalendar-header,
  .MuiDayCalendar-weekContainer {
    display: flex !important;
    gap: 8px !important;
  }
  .MuiDayCalendar-monthContainer {
    display: flex !important;
    flex-direction: column !important;
    padding-top: 16px !important;

    @media (min-height: 570) {
      gap: 10px !important;
    }
    position: unset !important;
  }
  .MuiPickersDay-root {
    font-family: "Ringside Regular-Book" !important;
    font-weight: 325 !important;
    font-size: 18px !important;
    line-height: 24px !important;
  }

  & .MuiPickersDay-today {
    border: 2px solid ${Colors.neutral_gray_500} !important;
  }
  .MuiTypography-root {
    color: ${Colors.neutral_gray_900} !important;
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    line-height: 24px !important;
    text-transform: capitalize !important;
  }
  .Mui-selected {
    background-color: ${Colors.neutral_gray_500} !important;
    color: ${Colors.white} !important;
    border: 2px solid ${Colors.neutral_gray_500} !important;
    font-family: "Ringside Regular-Bold" !important;
  }
`;

export const StyledYearCalendar = styled(YearCalendar)`
  gap: 20px 0px !important;
  min-height: inherit !important;
  .MuiYearCalendar-root {
    width: 100% !important;
    overflow: scroll !important;
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .Mui-selected {
    background-color: ${Colors.neutral_gray_500} !important;
    font-family: "Ringside Regular-Bold" !important;
  }
  .Mui-disabled {
    color: ${Colors.neutral_gray_400} !important;
  }
  .MuiPickersYear-yearButton {
    font-family: "Ringside Regular-Book";
    font-weight: 325 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }
`;

export const StyledMonthCalendar = styled(MonthCalendar)`
  gap: 30px 0px !important;

  color: ${Colors.neutral_gray_900} !important;

  .MuiPickersMonth-monthButton {
    font-family: "Ringside Regular-Book" !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }

  .Mui-selected {
    background-color: ${Colors.neutral_gray_500} !important;
    font-family: "Ringside Regular-Bold" !important;
  }
  .Mui-disabled {
    color: ${Colors.neutral_gray_400} !important;
  }
`;

export const StyledRowButtons = styled(Grid)`
  display: flex;
  margin-top: 0px !important;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
`;

export const StyledCalenderBox = styled(Box)`
  padding: 0 16px;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
  margin-top: 16px !important;
`;

export const StyledActionButton = styled(Button)<{ selected: boolean }>`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  padding: 8px 16px !important;
  font-size: 16px !important;
  line-height: 24px !important;
  border-radius: 8px !important;
  text-transform: capitalize !important;
  color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.white : Colors.primary_600} !important;
  background-color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.primary_600 : "transperent"} !important;
`;

export const ButtonBox = styled(Box)`
  padding: 8px;
  width: 50%;
`;
